import { API_URL, CLIENT_ID } from "../constants";

const openGoogleLogin = () => {
  const googleAuthUrl = "https://accounts.google.com/o/oauth2/v2/auth";
  const redirectUri = "api/auth/login/google";

  const scope = [
    "https://www.googleapis.com/auth/userinfo.email",
    "https://www.googleapis.com/auth/userinfo.profile",
    "https://www.googleapis.com/auth/drive.file",
  ].join(" ");

  const params = {
    response_type: "code",
    client_id: CLIENT_ID,
    redirect_uri: `${API_URL}${redirectUri}`,
    prompt: "consent",
    access_type: "offline",
    scope,
  };

  const urlParams = new URLSearchParams(params).toString();
  window.location = `${googleAuthUrl}?${urlParams}`;
};

export default openGoogleLogin;
